<template>
    <div class="materialInfo" v-loading="loading">
        <div class="materialInfo-header">
            <InfoHeader title="工单详情-指派" @backPage="handleBackPage">
                <el-popover
                    placement="right-start"
                    title="该工单需求未指派完成，请全部指派后再提交："
                    width="400"
                    trigger="manual"
                    v-model="popoverVisible">
                    <div class="tip-list">
                        <div class="mb10" style="max-height: 50vh;overflow-y: auto;">
                            <p v-for="(item, index) in errValidList" :key="index">
                                {{index+1}}.任务ID{{item.detail_id}}，少于剩余可指派数{{item.material_num - item.surplusNum }}个
                            </p>
                        </div>
                        <div style="text-align: center;"><el-button @click="popoverVisible = !popoverVisible" type="primary" size="mini"><span>关闭</span></el-button></div>
                    </div>
                    <el-button  slot="reference" type="primary" class="ml40" plain @click="handleSubmit" :loading="formLoading">提交</el-button>
                </el-popover>
                <el-button  type="warning" class="ml20" plain v-if="getCurAuth('reject_work_order')"
                            :disabled="!info.can_rejected"
                            @click="handleBlank">驳回</el-button>
            </InfoHeader>
        </div>

        <div class="materialInfo-con pt10">
            <div class="left-info">
                <div class="wrap" v-show="show">
                    <div class="info-tabs">
                        <el-tabs v-model="activeName" stretch>
                            <el-tab-pane label="工单信息" name="info">
                                <span slot="label" class="font12px text-bold">工单信息</span>
                            </el-tab-pane>
                            <el-tab-pane label="工单流转" name="steps">
                                <span slot="label" class="font12px text-bold">工单流转</span>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="con" v-loading="info_loading">
                        <MaterialInfo :info="info" v-if="activeName == 'info'" />
                        <Materialsteps :stepsList="log" v-else />
                    </div>
                </div>
                <div class="wrap" v-show="!show"><div class="empty-box"></div></div>
                <div class="info-tabs-toggle" @click="handleToggle">
                    <i v-if="show" class="el-icon-caret-left"></i>
                    <i v-else class="el-icon-caret-right"></i>
                </div>
            </div>
            <div class="right-table">
                    <div class="con">
                        <el-table
                            :data="tableData"
                            :header-cell-style="{ background: '#e8eaec', color: '#333' }"
                            style="width: 100%"
                            size="mini"
                            ref="table"
                            row-key="detail_id"
                            :expand-row-keys="expandRowKeys"
                            @expand-change="expandChange"
                            @selection-change="handleSelectionChange"
                            :key="curKeys"
                            stripe
                        >
                            <el-table-column
                                type="selection"
                                width="40"
                                v-if="type == 2 && tagsActive != 2"
                            >
                            </el-table-column>

                            <el-table-column type="expand">
                                <template slot-scope="scope">
                                    <MaterialsTableExpand :orderId="scope.row.id" :tagsActive="tagsActive" :rows="scope.row"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="任务ID"
                                prop="detail_id">
                                <template slot-scope="scope">
                                    <div @click="toggleRowExpansion(scope.row)">
                                        {{ scope.row.detail_id }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                width="80"
                                v-if="type == 2 || tagsActive == 2"
                            >
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini" @click="handleWithdraw(scope.row)" v-if="getCurAuth('work_order_assign')">指派</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="需求数量"
                                prop="material_num">
                                <template slot-scope="scope">
                                    <div @click="toggleRowExpansion(scope.row)">
                                        {{ scope.row.material_num }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="剩余可指派数量"
                                prop="material_num"
                                width="120"
                                v-if="tagsActive == 1"
                            >
                                <template slot-scope="scope">
                                    <span @click="toggleRowExpansion(scope.row)">
                                        {{scope.row.material_num - scope.row.surplusNum }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="可重新指派数量"
                                prop="material_num"
                                width="120"
                                v-if="tagsActive == 2"
                            >
                                <template slot-scope="scope">
                                    <span @click="toggleRowExpansion(scope.row)">
                                        {{scope.row.can_redo_assign_num }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="期望完成日期"
                                prop="expected_end_time"
                                width="120"
                            >
                                <template slot-scope="scope">
                                    <div @click="toggleRowExpansion(scope.row)">
                                        {{scope.row.expected_end_time }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="任务紧急程度"
                                prop="urgent_level"
                                width="120"
                            >
                                <template slot-scope="scope">
                                    <div @click="toggleRowExpansion(scope.row)">
                                        <span v-if="scope.row['urgent_level'] == 2" style="color: #ff0000;">{{scope.row['urgent_level_text']}}</span>
                                        <span v-else>{{scope.row['urgent_level_text']}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="媒体"
                                prop="plat_name">
                                <template slot-scope="scope">
                                    <div @click="toggleRowExpansion(scope.row)">
                                        {{scope.row.plat_name }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="素材格式"
                                prop="material_format">
                                <template slot-scope="scope">
                                    <div @click="toggleRowExpansion(scope.row)">
                                        {{scope.row.material_format }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="素材尺寸">
                                <template slot-scope="scope">
                                    <div @click="toggleRowExpansion(scope.row)">{{scope.row.width}} * {{scope.row.height}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="素材大小">
                                <template slot-scope="scope">
                                    <div @click="toggleRowExpansion(scope.row)"><={{scope.row.material_size}}{{scope.row.material_size_unit}}</div>
                                </template>
                            </el-table-column>
                        </el-table>


<!--                        <div class="tar pt10" style="background-color: #fff;">-->
<!--                            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"-->
<!--                                           :current-page="currentPage" :page-sizes="[30, 50, 100]" :page-size="pageSize"-->
<!--                                           layout="total, sizes, prev, pager, next, jumper" :total="total">-->
<!--                            </el-pagination>-->
<!--                        </div>-->

                        <div>
                            <h5 class="font12px mb10 mt10 pl8">指派设置</h5>
                            <div>
                                <AssignSet :producer_options="producer_options"
                                           :multipleSelection="multipleSelection"
                                           :tagsActive="tagsActive"
                                           :pageFuncNames="pageFuncNames"
                                           :schedulingGroupName="info.scheduling_group_name"
                                           @radio-click="handleRadioClick" @batch-click="handleBatch"/>
                            </div>
                        </div>

                    </div>
            </div>
        </div>

    </div>
</template>
<script>
import InfoHeader from "@/views/workOrder/components/infoHeader.vue";
import MaterialExtendItem from "@/views/workOrder/components/materialExtendItem.vue";
import MaterialInfo from './info.vue'
import Materialsteps from '@/views/workOrder/components/steps.vue'
import MaterialsTableExpand from './tableExpand.vue'
import AssignSet from './assignSet.vue'
import {withOncedrawModal} from './modal'
import {withdrawModal as infowithdrawModal} from '../assign/modal'
import { isEqual, cloneDeep, find } from 'lodash'
import API from "@/api/workOrder/material";
import {mapState, mapActions, mapMutations} from "vuex";
import matomoFun from "@/utils/matomo.js";
export default {
    name: 'assignInfo',
    components:{
        MaterialExtendItem,
        InfoHeader,
        MaterialInfo,
        Materialsteps,
        MaterialsTableExpand,
        AssignSet
    },
    props:{
        query:{
            type: Object,
            default: function () {
                return {}
            }
        },
        reload:{
            type: String,
            default: ''
        },
        pageFuncNames:Array,
    },
    data(){
        return {
            show: true,
            activeName: 'info',
            activeTableExpandName: 'ready',
            info:[], //工单信息
            log:[], //工单流转
            type: 1,  // 1 统一指派  2 单独指派
            curKeys:1,
            batchForm:null, // 统一指派
            producer_options:[], //制作人
            multipleSelection: [],
            tableData: [],
            cacheTableData:[],
            result_reload: true,
            loading: false,
            info_loading: false,
            order_id: '',
            tagsActive: '',
            tags: [{
                value: '1',
                label: '待指派'
            }, {
                value: '2',
                label: '已指派'
            }],
            expandRowKeys:[],
            formLoading: false,
            popoverVisible: false,
            errValidList: []
        }
    },
    computed: {
        // 计算表格高度为视口高度减去160像素
        tableHeight() {
            return `calc(100vh - 212px)`;
        },
        ...mapState({
            uploadQueue: state => state.workOrder.workTaskList,
        }),
    },
    watch:{
        result_reload:{
            handler(val){
                if(!val){
                    this.$store.commit('workOrder/UPDATE_CREATE_PAGE_STATUS', !val);
                }
                window.removeEventListener('beforeunload', this._beforeunload);
                if (!val) {
                    window.addEventListener("beforeunload", this._beforeunload)
                }
            },
        },
        'query':{
            handler(n) {
                const {id, tagsActive} = n
                this.order_id = id
                // this.tagsActive = tagsActive

                // if(tagsActive == 2) {
                //     this.type = 2
                // }
                this.curKeys++ //处理表格变更
                this.fetchInfo(id)
                this.fetchLog(id)
                setTimeout(()=>{
                    this.fetchDetail(id)
                },120)
                
                this.fetchProducer()

                // setTimeout(()=>{
                //     if(Object.keys(this.$route.query).length != 0) {
                //         this.$router.path({name:'work_order_material', query:{}})
                //     }
                // },100)
            },
            deep: true,
            immediate: true
        },
        'tagsActive': {
            handler(val) {
                // let name_list = this.tags.filter(item=>item.value == val)
                // let cur_name = '待指派'
                // if(name_list && name_list.length !== 0 && val) {
                //     cur_name = name_list[0].label
                // }
                this.CHANGE_BREADCRUMB(['指派管理', '工单详情'])
            },
            immediate: true
        },
    },
    mounted() {

    },
    methods:{
        ...mapActions('workOrder', ['READ_ROUTE_LIST']),
        ...mapMutations('app', [
            'CHANGE_BREADCRUMB',
        ]),
        _beforeunload(event) {
            event.preventDefault();
            event.returnValue = "确定要离开吗？系统可能不会保存您所做的更改";
        },
        // 操作权限
        getCurAuth(name) {
            return this.pageFuncNames.includes(name);
        },
        pushMatomo(name) {
            let cur_name = find(this.tags, item=>item.value == this.query.tagsActive)
            let behaviorCategory = `素材工单(指派管理-${cur_name?.label})`
            matomoFun.trackEvent(behaviorCategory, '点击', name)
        },
        fetchInfo(id) {
            this.info_loading = true
            API.getWorkAssignOrderInfo({order_id:id}).then(res=>{
                this.info = res.data
                this.tagsActive = res.data.order_status

                if(this.tagsActive == 2) {
                    this.type = 2
                }
            },(err)=>{
                this.$message.error(err.info)
            }).finally(()=>{
                this.info_loading = false
            })
        },
        fetchLog(id) {
            API.getWorkAssignOrderLog({order_id:id}).then(res=>{
                this.log = res.data
            },(err)=>{
                this.$message.error(err.info)
            })
        },
        fetchDetail(id) {
            this.loading = true
            API.getWorkAssignOrderDetailList({order_id:id}).then(res=>{
                this.tableData = res.data.map(item=>{
                    item.surplusNum = item.detail_assign.reduce((prev, cur)=>{
                        // let cur_can_num = Number(cur.num)-Number(cur.upload_num) <= 0 ? 0 : (Number(cur.num)-Number(cur.upload_num))
                        // return Number(cur_can_num) + Number(prev)
                        return Number(cur.num) + Number(prev)
                    }, 0)
                    item.onceIndex = 0  //已指派使用 区分是否第一次已指派

                    let new_detail_assign = item.detail_assign.map(itemc=>{
                        let lock_num = 0
                        if(Number(itemc.num) < Number(itemc.upload_num)) {
                            lock_num = Number(itemc.num)
                        }else{
                            lock_num = Number(itemc.upload_num)
                        }
                        return {...itemc,prev_cache_num:itemc.num, lock_num}
                    })

                    let new_detail_can_redo_assign = item.detail_can_redo_assign.map(itemcan=>({...itemcan, lock_num:0}))
                    let new_detail_cannot_redo_assign = item.detail_cannot_redo_assign.map((itemno=>{
                        let lock_num = Number(itemno.cache_num) <= Number(itemno.upload_num) ? Number(itemno.cache_num) : 0
                        return {...itemno, lock_num}
                    }))
                    return {...item,
                        detail_assign:new_detail_assign,
                        detail_cannot_redo_assign: new_detail_cannot_redo_assign,
                        detail_can_redo_assign: new_detail_can_redo_assign
                    }
                })
                this.cacheTableData = cloneDeep(this.tableData)
                this.curKeys++
                // this.tableData = res.data.map(item=>({...item,surplusNum: 0,detail_assign:item.detail_assign ? item.detail_assign :[]}))
            },(err)=>{
                this.$message.error(err.info)
            }).finally(()=>{
                this.loading = false
            })
        },
        fetchProducer() {
            API.getAssignOrderProducer().then(res=>{
                this.producer_options = this.modifyIdsToValues(res.data)
            },err=>{
                this.$message.error(err.info)
            })
        },
        // 返回上一页
        handleBackPage() {
            this.curKeys++
            if(this.tagsActive == 2) {
                this.pushMatomo('列表(指派-返回)')
                this.result_reload = isEqual(this.tableData, this.cacheTableData);
                if(!this.result_reload) {
                    this.$confirm('取消后已经修改的内容不会保存，确认要取消吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$store.commit('workOrder/UPDATE_CREATE_PAGE_STATUS', false);
                        this.routerBack()
                    }).catch(() => {});
                }else{
                    this.routerBack()
                }
                return
            }
            this.pushMatomo('列表(指派-返回)')
            this.routerBack()
            // this.$emit('changePage','AssignPage',{});
        },
        // 返回路由逻辑
        routerBack() {
            if(window.history.length > 1) {
                this.$router.go(-1)
            }else{
                this.$router.replace({
                    name:'work_order_material',
                    query: {
                        topage: 'AssignPage'
                    },
                    params:{
                        menuReload: 1
                    }
                });
            }
        },
        // 撤回
        handleBlank() {
            let isEqul = this.uploadQueue.some(item=>item.order_id == this.order_id)
            if(isEqul) {
                return this.$message.warning('素材正在上传中，无法继续操作')
            }
            this.pushMatomo('列表(指派-驳回)')
            let cur_name = find(this.tags, item=>item.value == this.tagsActive)
            let behaviorCategory = `素材工单(指派管理-${cur_name?.label})`
            const {vm} = infowithdrawModal(
                {
                    props: {
                        id: this.order_id,
                        name: behaviorCategory,
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            vm.close()
                            // this.$emit('changePage','AssignPage',{}, 'edit');
                            this.handleToPage('edit')
                        },
                    },
                    on: {
                        close: () => {
                            vm.close()
                            this.pushMatomo('列表(指派-驳回-取消)')
                        }
                    }
                }
            )
        },
        modifyIdsToValues(arr) {
            return arr.map(obj => {
                const newObj = { ...obj };
                if (newObj.children && newObj.children.length > 0) {
                    newObj.children = this.modifyIdsToValues(newObj.children);
                }
                if (newObj.hasOwnProperty('id')) {
                    newObj.value = newObj.id
                    newObj.label = newObj.name
                    // newObj.disabled = newObj.user_status == 0 ? true : false
                    delete newObj.id
                    delete newObj.name
                    // delete newObj.user_status
                }

                return newObj;
            });
        },
        // 统一指派
        fetchBatch() {
            if(!this.batchForm) {
                this.$message.error('必填项，不可为空')
                return
            }
            if(this.batchForm.set_date_type == 2 && !this.batchForm.finish_time) {
                this.$message.error('指定日期指派设置完成时间，不可为空')
                return
            }
            if(!this.batchForm.producer_uids) {
                this.$message.error('统一指派制作人，不可为空')
                return
            }
            this.formLoading = true
            API.postAssignOrderAll({
                order_id:this.order_id,
                set_date_type: this.batchForm.set_date_type,
                finish_time: this.batchForm.finish_time,
                producer_uids:this.batchForm.producer_uids
            }).then(res=>{
                this.$message.success(res.info)
                this.formLoading = false
                // this.$emit('changePage','AssignPage',{}, 'edit');
                this.handleToPage('edit')
            },err=>{
                this.$message.error(err.info)
            }).finally(()=>{
                this.formLoading = false
            })
        },
        // 分任务指派
        fetchTask() {
            let details = this.tableData.map(item=>{
                let detail_assign = item.detail_assign.map(deItem=>{
                    return {
                        num: deItem.num,
                        finish_time: deItem.finish_time,
                        producer_uids: deItem.producer_uids
                    }
                })
                return {
                    detail_id: item['detail_id'],
                    assign_detail: detail_assign
                }
            })
          this.formLoading = true
          API.postAssignOrderTask({
              order_id:this.order_id,
              details: JSON.stringify(details)
          }).then((res)=>{
              this.$message.success(res.info)
              this.formLoading = false
            //   this.$emit('changePage','AssignPage',{}, 'edit');
            this.handleToPage('edit')
          },err=>{
              this.$message.error(err.info)
          }).finally(()=>{
              this.formLoading = false
          })
        },
        // 分任务重新指派
        fetchRedoTask() {
            this.result_reload = isEqual(this.tableData, this.cacheTableData);
            if(this.result_reload) {
                return this.$message.warning('未修改任何内容 ，无需重新指派')
            }
            let details = this.tableData.map(item=>{
                let detail_assign = item.detail_assign.map(deItem=>{
                    return {
                        num: deItem.num,
                        finish_time: deItem.finish_time,
                        producer_uids: deItem.producer_uids,
                        detail_assign_id: deItem.detail_assign_id ? deItem.detail_assign_id : '',
                        upload_num: deItem.upload_num ? deItem.upload_num : 0,
                    }
                })
                return {
                    detail_id: item['detail_id'],
                    assign_detail: detail_assign
                }
            })
            this.formLoading = true
            API.postRedoAssignOrderTask({
                order_id:this.order_id,
                details: JSON.stringify(details)
            }).then((res)=>{
                this.$message.success(res.info)
                this.formLoading = false
                // this.$emit('changePage','AssignPage',{}, 'edit');
                this.handleToPage('edit')
            },err=>{
                this.$message.error(err.info)
            }).finally(()=>{
                this.formLoading = false
            })
        },
        handleToPage(type) {
            this.$router.push({
                name:'work_order_material',
                query: {
                    topage: 'AssignPage',
                    reload: type,
                    tagsActive: this.query.tagsActive ? this.query.tagsActive.toString() : '1'
                },
                params:{
                    menuReload: 1
                }
            });
        },
        // 提交
        handleSubmit() {
            

            let isEqul = this.uploadQueue.some(item=>item.order_id == this.order_id)
            if(isEqul) {
                return this.$message.warning('该任务正在上传素材，无法继续操作，素材上传完成后可继续操作')
            }
            this.pushMatomo('列表(指派-提交)')
            if(this.type == 1) {
                
               this.fetchBatch()
            }else if (this.type == 2) {
                let pop_result = this.tableData.filter(item=>(item.material_num - item.surplusNum) !==0)
                if(pop_result.length !== 0) {
                    this.errValidList = pop_result
                    this.popoverVisible = true
                    return
                }
                if(this.tagsActive == 2) {
                    this.fetchRedoTask()
                }else {
                    this.fetchTask()
                }
            }
        },
        // 工单信息与流转 展开收起
        handleToggle() {
            this.show = !this.show
            this.activeName = ''
            this.$nextTick(()=>{
                this.activeName = 'info'
            })
        },
        // 单个 指派任务
        handleWithdraw(rows) {

            const {vm} = withOncedrawModal(
                {
                    props: {
                        rows:rows,
                        producer_options:this.producer_options,
                        tagsActive: this.tagsActive,
                        schedulingGroupName: this.info.scheduling_group_name
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            let clone_deep_data_0 = cloneDeep(data[0])

                            // rows.detail_assign = [...rows.detail_assign, ...data]
                            rows.detail_assign = clone_deep_data_0
                            // rows.detail_can_redo_assign = data[0]
                            rows.surplusNum = rows.detail_assign.reduce((prev, cur)=>{
                                    // let cur_can_num = Number(cur.num)-Number(cur.upload_num) <= 0 ? 0 : (Number(cur.num)-Number(cur.upload_num))
                                    // return Number(cur_can_num) + Number(prev)
                                return Number(cur.num) + Number(prev)
                                }, 0)
                            if(this.tagsActive == 2) {
                                // 以下废弃
                                let clone_deep_data_1 = cloneDeep(data[1])
                                rows.detail_can_redo_assign = clone_deep_data_1
                                rows.onceIndex = 1
                            }
                            // if (this.expandRowKeys.includes(rows.detail_id)) {
                            //     this.expandRowKeys = this.expandRowKeys.filter((val) => val !== rows.detail_id);
                            // } else {
                            //     this.expandRowKeys = []; //手风琴模式，
                            //     this.expandRowKeys.push(rows.detail_id);
                            // }
                            if(!this.expandRowKeys.includes(rows.detail_id)) {
                                this.expandRowKeys.push(rows.detail_id);
                            }
                            vm.close()
                        },
                    }
                }
            )
        },
        expandChange(row, expandeRows) {
            this.expandRowKeys = expandeRows.map(item=>item.detail_id)
        },
        handleRadioClick(val) {
            this.type = val
            if(this.type == 1) {
                // 统一指派 分任务指派的详情
                this.tableData.map(item=>{
                    item.detail_assign = []
                    item.surplusNum = item.detail_assign.reduce((prev, cur)=>{
                        // let cur_can_num = Number(cur.num)-Number(cur.upload_num) <= 0 ? 0 : (Number(cur.num)-Number(cur.upload_num))
                        // return Number(cur_can_num) + Number(prev)
                        return Number(cur.num) + Number(prev)
                    }, 0)
                    return {...item}
                })
                // detail_assign
            }
            this.curKeys++
        },
        // 指派数量计算
        handleBatch(val) {
            if(this.type == 1) {
                this.batchForm = val
            }else if(this.type == 2) {
                let cur_detail_id = this.multipleSelection.map(item=>item.detail_id)
                if(!Array.isArray(val)) return
                let cur_mul_num = Number(val[0].num) //批量添加的数量
                let res_table = this.tableData.map(item=>{
                    if(cur_detail_id.includes(item.detail_id)){
                        // 批量处理展示数组

                        // let cur_can_redo_assign_num = Number(item.can_redo_assign_num)
                        let cur_can_redo_assign_num = Number(item.material_num)
                        let maxLenth = item.detail_assign.reduce((prev, cur)=>{
                            // return (Number(cur.num)-Number(cur.upload_num)) + Number(prev)
                            // let cur_can_num = Number(cur.num)-Number(cur.upload_num) <= 0 ? 0 : (Number(cur.num)-Number(cur.upload_num))
                            // return Number(cur_can_num) + Number(prev)
                            return Number(cur.num)+ Number(prev)
                        }, 0)

                        // let addNum = (cur_can_redo_assign_num - maxLenth) // 可添加的数量
                        let addNum = (cur_can_redo_assign_num - maxLenth) // 可添加的数量

                        if(addNum > 0) {

                            let some_index = item.detail_assign.findIndex((cur)=>{
                                let combination_item = cur.finish_time + '-' + cur.producer_uids.join(',');
                                let combination_val = val[0].finish_time + '-' + val[0].producer_uids.join(',');
                                if (combination_item === combination_val) {
                                    return true
                                }
                                return false
                            })
                            if(cur_mul_num >= addNum) {
                                if(some_index != -1) {
                                    item.detail_assign[some_index].num = Number(item.detail_assign[some_index].num) + Number(addNum)
                                }else{
                                    item.detail_assign.push({...val[0], lock_num: 0, num:addNum})
                                }
                            }else if(cur_mul_num < addNum){
                                if(some_index != -1) {
                                    item.detail_assign[some_index].num = Number(item.detail_assign[some_index].num) + Number(cur_mul_num)
                                }else{
                                    item.detail_assign.push({...val[0], lock_num: 0, num:cur_mul_num})
                                }
                            }

                        }


                        item.surplusNum = item.detail_assign.reduce((prev, cur)=>{
                            // let cur_can_num = Number(cur.num)-Number(cur.upload_num) <= 0 ? 0 : (Number(cur.num)-Number(cur.upload_num))
                            // return Number(cur_can_num) + Number(prev)
                            return Number(cur.num) + Number(prev)
                        }, 0)


                        //批量处理 可指派数组 以下已经废弃
                        if(this.tagsActive == '2') {

                            let cur_can_redo_assign_num_2 = Number(item.can_redo_assign_num)
                            let maxLenth_can = item.detail_can_redo_assign.reduce((prev, cur)=>{
                                // let cur_can_num = Number(cur.num)-Number(cur.upload_num) <= 0 ? 0 : (Number(cur.num)-Number(cur.upload_num))
                                // return Number(cur_can_num) + Number(prev)
                                return Number(cur.num)+ Number(prev)
                            }, 0)
                            console.log('0d',cur_can_redo_assign_num_2, maxLenth_can)

                            let addNum_can = (cur_can_redo_assign_num_2 - maxLenth_can) // 可添加的数量
                            if(Number(addNum_can) > 0) {
                                let some_cannot_index = item.detail_can_redo_assign.findIndex((cur)=>{
                                    let combination_item = cur.finish_time + '-' + cur.producer_uids.join(',');
                                    let combination_val = val[0].finish_time + '-' + val[0].producer_uids.join(',');
                                    if (combination_item === combination_val) {
                                        return true
                                    }
                                    return false
                                })
                                if(cur_mul_num >= addNum_can) {
                                    if (some_cannot_index != -1) {
                                        item.detail_can_redo_assign[some_cannot_index].num = Number(item.detail_can_redo_assign[some_cannot_index].num) + Number(addNum_can)

                                    }else{
                                        item.detail_can_redo_assign.push({...val[0], lock_num: 0, num:addNum_can})
                                    }
                                }else{
                                    if (some_cannot_index != -1) {
                                        item.detail_can_redo_assign[some_cannot_index].num = Number(item.detail_can_redo_assign[some_cannot_index].num) + Number(cur_mul_num)
                                    }else{
                                        item.detail_can_redo_assign.push({...val[0], lock_num: 0, num:cur_mul_num})
                                    }

                                }
                                item.onceIndex = 0
                            }
                        }
                    }
                    return {...item}
                })
                this.tableData = res_table
            }
        },



        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 折角矩形 标签点击
        handleClick(val) {
            console.log(val)
            this.list = [1,2]
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
        },
        toggleRowExpansion(row) {
            this.$refs.table.toggleRowExpansion(row)
        },
    }
}
</script>
<style lang="scss" scoped>
    .materialInfo{
        width: 100%;
        .materialInfo-con{
            height: calc(100vh - 100px);
            width: 100%;
            display: flex;
            justify-content: space-between;
            .left-info{
                height: 100%;
                margin-right: 10px;
                position: relative;
                .info-tabs-toggle{
                    position: absolute;
                    right: -10px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 10px;
                    height: 80px;
                    background-color: #409EFF;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    i{
                        color: #fff;
                    }
                }
                .wrap{
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    .info-tabs{
                        background-color: #fff;
                        width: 100%;
                        text-align: center;
                    }
                    .con{
                        background-color: #fff;
                        width: 200px;
                        padding: 0 6px;
                        height: 0;
                        flex: 1;
                        overflow: auto;
                    }
                }
                ::v-deep .el-tabs__item{
                    line-height: 32px;
                    height: 36px;
                }
            }
            .right-table{
                flex: 1;
                overflow-x: hidden;
                height: 100%;
                display: flex;
                flex-direction: column;
                .con{
                    background-color: #fff;
                    height: 0;
                    flex: 1;
                    overflow-x: hidden;
                    overflow-y: auto;
                }

                ::v-deep .el-table__expanded-cell{
                    background-color: #f2f2f2!important;
                }
            }
            .empty-box{
                width: 3px;
                border: solid 1px #ccc;
                height: 100%;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        width: 200px;
        opacity: 1;
        transition: all .6s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        width: 0;
        opacity: 0;
    }

    .material-table-expand{
        padding:0 10px;
        .material-table-expand-con{
            //background-color: #F1F4F9;
        }
        .material-table-expand-header{
            display: flex;
            flex-wrap: wrap;
            span{
                padding-right: 20px;
                padding-bottom: 6px;
            }
        }
        .material-table-expand-cards{
            display: flex;
            flex-wrap: wrap;
            .material-table-expand-cards-item{
                margin: 0 5px 10px 5px;
            }
        }
    }
</style>
<style lang="scss">
.disabled-column .el-checkbox__input {
    display: none;
}
</style>
